import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWords } from '../state_words';

export const local_words_translating_in_progress_delete = (payload: DTO__word[]): PayloadAction<DTO__word[]> => ({
  type: ENUM__redux_action.WORDS_TRANSLATING_IN_PROGRESS_DELETE,
  payload,
});

export const init_local_words_translating_in_progress_delete = (state: StateWords, action: PayloadAction<DTO__word[]>) => {
  for (let word of action.payload) {
    let wordsInLanguage = state.words_translating_in_progress.get(word.language) || new Set<string>();

    wordsInLanguage.delete(word.word_english);

    state.words_translating_in_progress.set(word.language, wordsInLanguage);
  }

  //need to update map to trigger re-render
  state.words_translating_in_progress = new Map(state.words_translating_in_progress);
};
